import React from 'react';
import { Stack, PrimaryButton, MessageBar, MessageBarType } from '@fluentui/react';

interface ActivityTableHeaderProps {
    onAddRecord: () => void;
    errorMessage: string | null;
    onDismissError: () => void;
}

export const ActivityTableHeader: React.FC<ActivityTableHeaderProps> = ({ onAddRecord, errorMessage, onDismissError }) => {
    return (
        <Stack tokens={{ childrenGap: 10 }}>
            <Stack horizontal>
                <PrimaryButton text="Add Activity" onClick={onAddRecord} />
            </Stack>
            {errorMessage && (
                <MessageBar messageBarType={MessageBarType.error} onDismiss={onDismissError} dismissButtonAriaLabel="Close">
                    {errorMessage}
                </MessageBar>
            )}
        </Stack>
    );
};
